<template>
  <div style="height: 100%; width: 100%; position: relative">
    <!-- <div style="overflow-y:auto; width:100%; height:100%; overflow-x:hidden;"> -->
    <div class="doctor-production-bg">
      <!-- -->
      <div class="player-wrap" v-if="!data.article_content">
        <div id="J_prismPlayer" class="prism-player"></div>
      </div>
      <div class="tabs-wrap" v-if="!isM">
        <tabs
          v-model="active"
          background="transparent"
          color="#1244f1"
          line-width="0.98rem"
          line-height="0.09rem"
          @click="onClick"
        >
          <tab title="简介" title-style="height:1.5rem;">
            <template #title>
              <p class="tabs-title">{{ tabText }}</p>
            </template>
            <div class="production-desc">
              <div class="production-doctor-info">
                <img
                  class="production-doctor-info-icon"
                  :src="data.doctor_photo"
                  alt
                />
                <div class="production-doctor-info-wrap">
                  <div class="production-doctor-name-wrap">
                    <!-- <p class="production-doctor-name">
                                                
                    </p>-->
                    <p class="production-doctor-dept">
                      <span class="production-doctor-name">{{
                        data.doctor_name
                      }}</span>
                      {{ data.department_name }} | {{ data.doctor_position }}
                    </p>
                  </div>
                  <p class="production-doctor-hospital">
                    {{ data.hospital_name }}
                  </p>
                </div>
                <img
                  @click="toDoctorHome"
                  class="to-doctor-home"
                  src="@/assets/images/doctor/to_doctor_home.png"
                  alt
                />
              </div>
              <p class="production-desc-title">{{ data.title }}</p>
              <div class="production-count-wrap">
                <div class="production-count-item">
                  <img
                    class="production-data-img"
                    src="@/assets/images/play_count.png"
                    alt
                  />
                  <p class="production-data-text">{{ data.view_num }}</p>
                </div>
                <div class="production-count-item" style="margin-left: 0.6rem">
                  <img
                    class="production-data-img"
                    src="@/assets/images/thumbsup_count.png"
                    alt
                  />
                  <p class="production-data-text">{{ data.praise_num }}</p>
                </div>
                <div class="production-count-item" style="margin-left: 0.6rem">
                  <img
                    class="production-data-img"
                    src="@/assets/images/comment_count.png"
                    alt
                  />
                  <p class="production-data-text">{{ data.comment_num }}</p>
                </div>
                <div style="flex: 1"></div>
                <span class="production-count-date">{{
                  data.release_time
                }}</span>
              </div>
              <div class="line"></div>
              <div
                :style="{ height: describe_height }"
                class="describe_height production-desc-content"
                v-html="data.describe"
                v-if="!data.article_content"
              >
                <!-- <p class="production-desc-content" ></p> -->
              </div>
            </div>
            <div class="html-content" :style="{ height: content_height }">
              <div v-html="data.article_content" class="content-item"></div>
            </div>
          </tab>
          <tab title="评论" title-style="height:1.5rem;">
            <template #title>
              <p class="tabs-title">评论</p>
            </template>
            <div
              class="production-comment"
              :style="{ height: comment_content_height }"
            >
              <comment-list
                ref="comment"
                :data="comment_list"
                :finished="comment_finished"
                @load-more="getComments(true)"
                @comment-click="commentClick"
                @comment-reply="commentReply"
              ></comment-list>
            </div>
          </tab>
          <template #nav-right>
            <div style="flex: 1"></div>
            <div class="popular-type">科普</div>
          </template>
        </tabs>
      </div>
      <template v-if="isM">
        <div class="production-desc">
          <div class="production-doctor-info">
            <img
              class="production-doctor-info-icon"
              :src="data.doctor_photo"
              alt
            />
            <div class="production-doctor-info-wrap">
              <div class="production-doctor-name-wrap">
                <!-- <p class="production-doctor-name">
                                                
                </p>-->
                <p class="production-doctor-dept">
                  <span class="production-doctor-name">{{
                    data.doctor_name
                  }}</span>
                  {{ data.department_name }} | {{ data.doctor_position }}
                </p>
              </div>
              <p class="production-doctor-hospital">{{ data.hospital_name }}</p>
            </div>
            <img
              @click="toM"
              class="to-doctor-home"
              src="@/assets/images/doctor/to_doctor_home.png"
              alt
            />
          </div>
          <p class="production-desc-title">{{ data.title }}</p>
          <div class="production-count-wrap">
            <div class="production-count-item">
              <img
                class="production-data-img"
                src="@/assets/images/play_count.png"
                alt
              />
              <p class="production-data-text">{{ data.view_num }}</p>
            </div>
            <div class="production-count-item" style="margin-left: 0.6rem">
              <img
                class="production-data-img"
                src="@/assets/images/thumbsup_count.png"
                alt
              />
              <p class="production-data-text">{{ data.praise_num }}</p>
            </div>
            <div style="flex: 1"></div>
            <span class="production-count-date">{{ data.release_time }}</span>
          </div>
          <div class="line"></div>
          <div
            :style="{ height: describe_height }"
            class="describe_height production-desc-content"
            v-html="data.describe"
            v-if="!data.article_content"
          >
            <!-- <p class="production-desc-content" ></p> -->
          </div>
        </div>
        <div class="html-content" :style="{ height: content_height }">
          <div v-html="data.article_content" class="content-item"></div>
        </div>
      </template>
    </div>
    <div
      :class="['comment-wrap', show_input_box_mask ? 'input-box-mask' : '']"
      v-if="active == 1 && !isM"
    >
      <div style="flex: 1" @click="hideInputBox"></div>
      <comment-input-box
        ref="input_box"
        @show-input-box="showInputBoxMask"
        @send-message="sendMessage"
      ></comment-input-box>
    </div>
    <comment-sheet
      :item="comment_selected"
      v-if="show_comment_sheet && !isM"
      @cancel="commentSheetCancel"
      @delete="commentSheetDelete"
      @reply="commentSheetReply"
    ></comment-sheet>

    <img
      @click="show_poster = true"
      class="teach-page-share-poster"
      src="@/assets/images/doctor/share_poster.gif"
      alt
    />
    <div style="bottom: 6.5rem" class="teach-page-share-poster">
      <img @click="givePraise" :src="praise_url" alt />
      <p class="praise-text">{{ is_praise ? "&nbsp;" : "点赞" }}</p>
    </div>
    <div @click="clicklinklog" class="teach-page-msg" v-if="isappletlink">
      <div ref="lavContainer"></div>
    </div>
    <doctor-poster
      :data="data"
      v-if="show_poster"
      @poster-close="posterClose"
      :is_production="true"
    ></doctor-poster>
  </div>
  <!-- </div> -->
</template>

<script>
import { NativeMessageData, NativeMessagePush } from '@/js/nativeBridge/nativeMessage'
import { Tab, Tabs, Toast, Sticky } from 'vant'
import CommentList from '@/components/comment/CommentList'
import DoctorPoster from '@/components/Doctor/DoctorPoster'
import CommentInputBox from '@/components/comment/CommentInputBox'
import CommentSheet from '@/components/comment/CommentSheet'
import ItmeSvg from '@/components/svg/ItmeSvg'
import Player from '@/js/Player.js'
import Request from '@request'
import api from '@api'
import host from '@host'
import GATSocket from '@/js/socket/GATSocket.js'
import Utils from '@/js/Utils.js'
import lottie from 'lottie-web'
import lottie_xinxi from '../../../assets/svg/xinxi'
import { SocketTypePrefix, SocketMessageMaker } from '@/js/socket/SocketMessageMaker.js'
import GATExtension from '@/js/GATExtension.js'
// import ListLoader from '@/js/ListLoader.js'

export default {
  components: {
    Tab,
    Tabs,
    Sticky,
    DoctorPoster,
    CommentList,
    CommentInputBox,
    CommentSheet,
    ItmeSvg
  },
  props: {},
  data () {
    return {
      isM: false,
      tabText: '简介',
      content_height: '',
      comment_content_height: '',
      active: 0,
      player: null,
      data: {},
      nick_name: '',
      show_poster: false,
      isappletlink: true,
      appletlink: '',
      pageUrl: '',
      show_input_box_mask: false,
      socket: null,
      comment_list: [],
      comment_finished: false,
      comment_selected: null,
      show_comment_sheet: false,
      is_praise: false,
      praise_url: require('@/assets/images/doctor/praise.png'),
      describe_height: '',
      consult_url: ''
    }
  },
  created () {
    const nick_name = localStorage.getItem('pt_nick_name')
    if (!nick_name) {
      this.nick_name = Utils.randomNum(8)
      localStorage.setItem('pt_nick_name', this.nick_name)
    } else {
      this.nick_name = nick_name
    }
    this.isM = this.$route.query.isM ? true : false
    this.giveviews()
    this.getData()
    this.getComments()
    this.connectSocket()
  },
  mounted () {
    this.$nextTick(() => {
      const node = document.querySelector('.html-content')
      const describe_none = document.querySelector('.describe_height')
      if (node) {
        const body = document.querySelector('body')
        this.content_height =
          body.getBoundingClientRect().height -
          node.getBoundingClientRect().top +
          200 +
          'px'
        console.log(this.content_height)
      }
      if (describe_none) {
        const body = document.querySelector('body')
        this.describe_height =
          body.getBoundingClientRect().height -
          describe_none.getBoundingClientRect().top -
          40 +
          'px'
        console.log(this.describe_height)
      }
      lottie.loadAnimation({
        //初始化
        container: this.$refs.lavContainer, //在哪个dom容器中生效
        renderer: 'svg', //渲染方式svg
        animationData: lottie_xinxi //动画数据，这个必须要有
      })
    })
  },
  beforeDestroy () {
    this.player && this.player.dispose()
  },
  methods: {
    shareToWX () {
      this.$nativeBridge.sendMessage(
        new NativeMessageShare(document.querySelector('.posters_img').src)
      )
    },
    onClick () {
      this.$nextTick(() => {
        const node = document.querySelector('.html-content')
        if (node) {
          const body = document.querySelector('body')
          this.content_height =
            body.getBoundingClientRect().height -
            node.getBoundingClientRect().top +
            'px'
        }
        const commentNode = document.querySelector('.production-comment')
        if (commentNode) {
          const body = document.querySelector('body')
          this.comment_content_height =
            body.getBoundingClientRect().height -
            commentNode.getBoundingClientRect().top -
            100 +
            'px'
        }
        console.log(this.content_height, this.comment_content_height)
      })
    },
    getappletlink (production_id) {
      Request.post(api.doctor.getappletlink, {
        type: 4,
        id: production_id
      }).then(res => {
        const { data, status } = res
        if (data.length) {
          this.isappletlink = true
          this.appletlink = data[0].url || data[0].consult_url
          this.consult_url = data[0].consult_url
          this.pageUrl = data[0].pageUrl
        } else {
          this.isappletlink = false
        }
      })
    },
    clicklinklog () {
      Request.post(api.doctor.clicklinklog, {
        appletlink: this.appletlink
      }).then(res => {
        const { data } = res
        let ua = window.navigator.userAgent.toLowerCase()
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
          if (this.consult_url) {
            window.go(this.appletlink)
          } else {
            let pageUrl = this.pageUrl
            wx.miniProgram.getEnv(a => {
              if (a.miniprogram) {
                wx.miniProgram.navigateTo({ url: '/' + pageUrl })
              } else {
                window.go(this.appletlink)
              }
            })
          }
        } else {
          console.log('不是微信环境')
          window.go(this.appletlink)
        }
      })
    },
    createListLoader () { },
    giveviews () {
      Request.post(api.doctor.giveviews, {
        production_id: this.$route.query.production_id,
        is_virtual: 1,
        virtual_userid: this.nick_name
      }).then(res => { })
    },
    getData () {
      Request.post(api.doctor.productiondetail, {
        production_id: this.$route.query.production_id
      }).then(res => {
        const { data } = res
        this.data = data
        document.title = data.title
        if (data.article_content) {
          this.tabText = '文章'
        } else {
          this.tabText = '简介'
        }
        this.getappletlink(data.production_id)
        this.player && this.player.dispose()
        this.player = new Player({
          source: data.file_url,
          cover: data.file_cover,
          isLive: false,
          change (current_index) { }
        })
      })
    },
    getComments (is_load_more) {
      if (!is_load_more) {
        this.comment_list = []
      }
      if (this.$refs.comment) this.$refs.comment.setLoadingState(true)
      Request.post(api.comment.get_webcomments, {
        id: this.$route.query.production_id,
        userid: this.nick_name,
        type: 5,
        limit: 20,
        last_comments_id:
          this.comment_list.length > 0
            ? this.comment_list[this.comment_list.length - 1].comments_id
            : 0
      })
        .then(res => {
          const { data } = res
          this.comment_list = is_load_more
            ? [...this.comment_list, ...data.data]
            : data.data
          this.comment_finished = data.last_page == 1 || data.last_page == 0
          if (this.$refs.comment) this.$refs.comment.setLoadingState(false)
        })
        .catch(error => {
          console.log(error)
          if (this.$refs.comment) this.$refs.comment.setLoadingState(false)
        })
    },
    toDoctorHome () {
      this.$router.push({
        name: 'DoctorTeachMainPage',
        query: {
          doctor_id: this.data.doctor_id
        }
      })
    },
    posterClose () {
      this.show_poster = false
    },
    showInputBoxMask (is_show) {
      if (!is_show) this.comment_selected = null
      this.show_input_box_mask = is_show
    },
    hideInputBox () {
      this.$refs.input_box.cancel()
    },
    sendMessage (task) {
      task &&
        task(message => {
          const { text, images } = message
          return new Promise((resolve, reject) => {
            Request.post(api.comment.doctor_production, {
              parent_id: this.comment_selected
                ? this.comment_selected.comments_id
                : 0,
              production_id: this.$route.query.production_id,
              comments_content: text,
              userid: this.nick_name,
              comments_content_type: 1,
              comments_photo: images
            })
              .then(res => {
                const { data } = res
                resolve(data)
              })
              .catch(error => {
                console.log(error)
                reject(error)
              })
          })
        })
    },
    connectSocket () {
      const user_id = this.nick_name
      this.socket = new GATSocket({
        url: host.socket,
        messages: SocketMessageMaker.makes([
          {
            action: 'login',
            user_id
          },
          {
            action: 'joinGroup',
            user_id,
            groupId: SocketTypePrefix.docworks + this.$route.query.production_id
          }
        ]),
        components: [
          {
            type: 'comment',
            handle: data => {
              this.comment_list.unshift(data)
            }
          }
        ]
      })
    },
    commentClick (comment) {
      this.comment_selected = comment
      this.show_comment_sheet = true
    },
    commentReply (comment) {
      this.comment_selected = comment
      this.$refs.input_box.showInputBox('@' + comment.comments_username)
    },
    commentSheetCancel () {
      this.show_comment_sheet = false
      this.comment_selected = null
    },
    commentSheetDelete (task) {
      task &&
        task(comment => {
          return new Promise((resolve, reject) => {
            Request.post(api.comment.delete_comment, {
              userid: this.nick_name,
              comments_id: comment.comments_id
            })
              .then(res => {
                const { data, status, message } = res
                if (status == 200) {
                  GATExtension.Array.removeFirst(this.comment_list, item => {
                    return item.comments_id == comment.comments_id
                  })
                  resolve(data)
                  Toast(this.$t('comment.delete_success'))
                } else {
                  Toast(message)
                  reject(message)
                }
              })
              .catch(error => {
                Toast(this.$t('comment.delete_fail'))
                reject(error)
              })
          })
        })
    },
    commentSheetReply (comment) {
      this.show_comment_sheet = false
      this.$refs.input_box.showInputBox('@' + comment.comments_username)
    },
    givePraise () {
      if (this.is_praise) return
      Request.post(api.doctor.givepraise, {
        production_id: this.$route.query.production_id
      })
        .then(res => {
          if (res.status == 200) {
            Toast('点赞成功')
            this.is_praise = true
            this.praise_url = require('@/assets/images/doctor/praised.png')
            this.data.praise_num += 1
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    // 跳转微网站
    toM () {
      window.go(`https://m.docbook.com.cn/doctorMainPage?doctor_id=${this.data.doctor_id}`)
    }
  }
}
</script>
<style>
.prism-player .prism-big-play-btn {
  left: 50% !important;
  top: 50%;
  margin-left: -32px;
  margin-top: -32px;
}

.doctor-production-bg .van-tabs {
  width: 100%;
  background: white;
}
.describe_height {
  overflow-y: auto;
}
.doctor-production-bg .van-tabs__content {
  background: #f4f4f4;
}

.doctor-production-bg .van-tabs__wrap {
  height: 1.5rem !important;
}

.doctor-production-bg .van-tab {
  width: 3.5rem;
  -webkit-box-flex: none;
  -webkit-flex: none;
  flex: none;
}
</style>
<style scoped>
.html-content {
  /* height: 1000px; */
  overflow-x: hidden;
  overflow-y: auto;
  /*   */
}
.html-content .content-item {
  margin-top: 1.185rem;
  padding: 0 0.88rem;
  box-sizing: border-box;
  max-width: 580px;
  font-size: 0.83rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
}
.doctor-production-bg {
  width: 100%;
  height: 100%;
  background: #f4f4f4;
}

.player-wrap {
  width: 100%;
  height: 9rem;
}

.tabs-wrap {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.tabs-title {
  width: 3.5rem;
  height: 100%;
  line-height: 100%;
  text-align: center;
  font-size: 0.51rem;
  color: #222222;
}

.popular-type {
  margin-top: 0.4rem;
  margin-right: 0.64rem;
  width: 1.71rem;
  height: 0.77rem;
  background-color: #ffdabf;
  border-radius: 0.38rem;
  font-size: 0.51rem;
  color: #df6123;
  text-align: center;
}

.learning-type {
  margin-top: 0.4rem;
  margin-right: 0.64rem;
  width: 1.71rem;
  height: 0.77rem;
  background-color: #ccd7ff;
  border-radius: 0.38rem;
  font-size: 0.51rem;
  color: #1244f1;
  text-align: center;
}

.production-desc {
  padding-top: 0.4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 0.64rem;
  margin-right: 0.64rem;
  background: #f4f4f4;
}

.production-doctor-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 3rem;
  width: 100%;
  background: white;
  border-radius: 0.21rem;
}

.production-doctor-info-icon {
  margin-left: 0.43rem;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 1.2rem;
}

.production-doctor-info-wrap {
  margin-left: 0.5rem;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.production-doctor-name-wrap {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
}

.production-doctor-name {
  margin-right: 0.4rem;
  font-size: 0.73rem;
  color: #222222;
}

.production-doctor-dept {
  /* margin-left: 0.4rem; */
  font-size: 0.51rem;
  color: #888888;
}

.production-doctor-hospital {
  margin-top: 0.5rem;
  font-size: 0.51rem;
  color: #888888;
}

.to-doctor-home {
  width: 1.92rem;
  height: 0.98rem;
  margin-right: 0.43rem;
  cursor: pointer;
}

.production-desc-title {
  width: 100%;
  align-self: flex-start;
  margin-top: 0.4rem;
  font-size: 0.64rem;
  color: #222222;
  max-height: 1.8rem;
  overflow: hidden;
  word-wrap: break-word;
}

.production-count-wrap {
  margin-top: 0.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}

.production-count-item {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.production-data-img {
  width: 0.51rem;
  height: 0.49rem;
}

.production-data-text {
  margin-left: 0.2rem;
  font-size: 0.51rem;
  color: #888888;
}

.production-count-date {
  margin-right: 0.62rem;
  font-size: 0.51rem;
  color: #888888;
}

.line {
  margin-top: 0.62rem;
  height: 1px;
  width: 100%;
  background-color: #dedede;
  opacity: 0.7;
}

.production-desc-content {
  width: 100%;
  line-height: 1.02rem;
  font-size: 0.6rem;
  color: #222222;
  word-wrap: break-word;
}
.production-desc-content >>> img,
.production-desc-content >>> video {
  width: 100% !important;
}

.teach-page-share-poster {
  width: 1.9rem;
  position: absolute;
  right: 0.45rem;
  bottom: 3.5rem;
  cursor: pointer;
}

.praise-text {
  position: absolute;
  bottom: -0.3rem;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 0.4rem;
}

.comment-wrap {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
}

.input-box-mask {
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1111;
}

.production-comment {
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  padding-bottom: 2.14rem;
}
.teach-page-msg {
  width: 1.9rem;
  position: absolute;
  right: 0.45rem;
  bottom: 9rem;
  cursor: pointer;
}
</style>
